import React, { useCallback, useMemo, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

const FormLegalStatus = ({ setPage, page, data }) => {
  const [companyData, setData] = data;
  const [file, setFile] = useState(null);

  const validations = useMemo(
    () =>
      Yup.object().shape({
        companyRuc: Yup.string().required("No puede estar vacio"),
        companyCommercialName: Yup.string(),
      }),
    []
  );

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const formSubmit = useCallback(
    async (values, { setSubmitting, setFieldError }) => {
      setSubmitting(true);
      setData((prev) => {
        return {
          ...prev,
          legalStatus: {
            ...values,
            companyRucImage: file,
          },
        };
      });

      setPage((prev) => prev + 1);
      setSubmitting(false);
    },
    [setPage, page, file]
  );

  return (
    <Formik
      initialValues={companyData["legalStatus"]}
      onSubmit={formSubmit}
      validationSchema={validations}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <div className="form__companytitle text-center">Estado Legal</div>

          <div className="form__row row">
            <div className="col-sm-12 col-md-12">
              <label htmlFor="username">RUC de la Empresa</label>
              <Field
                type="text"
                name="companyRuc"
                id="companyRuc"
                required
              ></Field>
              {errors.companyRuc && touched.companyRuc && (
                <span className="form__validation form__validation--error">
                  {errors.companyRuc}
                </span>
              )}
            </div>
          </div>

          <div className="form__row row">
            <div className="col-sm-12 col-md-12">
              <label htmlFor="username">Nombre Comercial de la Empresa</label>
              <Field
                type="text"
                name="companyCommercialName"
                id="companyCommercialName"
              ></Field>
              {errors.companyCommercialName &&
                touched.companyCommercialName && (
                  <span className="form__validation form__validation--error">
                    {errors.companyCommercialName}
                  </span>
                )}
            </div>
          </div>

          <div className="form__description text-center">
            Adjuntar imagen de cédula RUC
          </div>

          <div className="form__row">
            <div className="col-sm-12 col-md-8">
              <input
                id="companyRucImage"
                type="file"
                name="companyRucImage"
                accept="image/png,image/jpeg"
                onChange={handleFileChange}
              />
            </div>
          </div>

          <div className="form_row row">
            <div className="col-sm-12 col-md-6">
              <button
                onClick={() => setPage(page - 1)}
                className="btn btn--gradient btn__icon btn__icon--door"
              >
                Atrás
              </button>
            </div>

            <div className="col-sm-12 col-md-6 mb-2">
              <button
                type="submit"
                className="btn btn--gradient btn__icon btn__icon--door"
              >
                Siguiente
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default FormLegalStatus;
